import React from "react";
import IconShare from "../../download-flow/icon-share";

import { connect } from "react-redux";
import { showModal } from "../../../actions/actions";

import classNames from "classnames";

const UploaderLink = ({ uploader }) => (
    <span className="designer">
        <a href={uploader.permalink} className="designer">
            By {uploader.fullName}
        </a>
    </span>
);

const InactiveIconMsg = () => (
    <div className="no-longer-available">This icon is no longer available.</div>
);

const CollectionIconLinks = ({ icon, showModal }) => (
    <li>
        <IconShare icon={icon} showModal={showModal} />
        <a
            href="#"
            className="ui_kit kit"
            data-icon-id={icon.id}
            data-url={icon.permalink}
        />
    </li>
);

const CollectionIcon = ({ icon, iconPreview, showModal }) => {
    return (
        <li key={icon.id} className={`icon ${iconPreview}`}>
            <a
                className={classNames({ inactive: !icon.isActive })}
                href={icon.permalink}
            >
                <img src={icon.previewUrl} alt={icon.term + " Icon"} />
            </a>
            <ul className="tip">
                <span className="tip-container">
                    <li>
                        <span className="term">
                            <a href={icon.permalink} title={icon.term}>
                                {icon.term}
                            </a>
                        </span>
                        <UploaderLink uploader={icon.uploader} />
                    </li>
                    {icon.isActive === 0 ? (
                        <InactiveIconMsg />
                    ) : (
                        <CollectionIconLinks
                            icon={icon}
                            showModal={showModal}
                        />
                    )}
                </span>
            </ul>

            <div className="kit-container" />
        </li>
    );
};

export default connect(
    null,
    {
        showModal
    }
)(CollectionIcon);
